import useGetActivityByKey from '../providers/ActivityKeyer/useGetActivityByKey';

export default useGetActivityByKey;
